import { Component, Input, Output, EventEmitter, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SysWorkflowDto, MasterDataServiceProxy, SysWorkflowStateDto } from '@shared/service-proxies/service-proxies';
import { SysWorkFlowDialogComponent } from '@shared/components/sys-work-flow/sys-work-flow-dialog.component';
import { CustomConfirmComponent } from '@shared/components/custom-confirm/custom-confirm.component';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { CustomCommon } from '@shared/custom-common/custom-common';

@Component({
    selector: 'sys-work-flow',
    templateUrl: './sys-work-flow.component.html',
    animations: [appModuleAnimation()],
    providers: [CustomConfirmComponent]
})
export class SysWorkFlowComponent extends AppComponentBase implements OnChanges {
    @Input() workflowCode: string;
    @Input() workflowDataCode: string;
    @Output() onClick: EventEmitter<any> = new EventEmitter();
    @Output() sendFieldCanEdit: EventEmitter<any> = new EventEmitter();

    lstWorkFlow: SysWorkflowDto[];
    currentWF: SysWorkflowStateDto;
    constructor(
        injector: Injector,
        private _masterDataServiceProxy: MasterDataServiceProxy,
        private _modalService: BsModalService,
        private popup: CustomConfirmComponent
    ) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges) {
        //Xử lý lấy dữ liệu hiển thị button
        if (changes.workflowCode.firstChange === false && changes.workflowCode.firstChange === false) {
            this._masterDataServiceProxy.getListWorkflowByUsrType(this.workflowCode, this.workflowDataCode).subscribe((rsWorkFlow: SysWorkflowDto[]) => {
                this.lstWorkFlow = rsWorkFlow;
            });
        }
    }

    _onClick(workFlow: SysWorkflowDto, event): void {
        this.popup.customConfirm((result: boolean) => {
            if (result) {
                //Xử lý truyền data workFlow khi click button
                let workFlowState = new SysWorkflowStateDto();
                workFlowState.init(workFlow);
                workFlowState.workflowCde = workFlow.workflowCode;
                workFlowState.actionName = workFlow.actionName;

                if (workFlow.isRequiredComment) {
                    //Hiển thị dialog nhập lý do
                    let reasonDialog: BsModalRef;
                    reasonDialog = this._modalService.show(SysWorkFlowDialogComponent, {
                        class: 'modal-lg',
                        initialState: {
                            reason: ''
                        }
                    });

                    //Nhận lý do từ dialog truyền về
                    reasonDialog.content.onSave.subscribe((reason) => {
                        if (reason !== undefined && reason !== '') {
                            workFlowState.remark = reason;
                            this.sendData(workFlowState, workFlow.workflowName, workFlow.tableName, event);
                        }
                    });
                } else {
                    this.sendData(workFlowState, workFlow.workflowName, workFlow.tableName, event);
                }
            }
        }, this.l(CustomCommon.DataSaved));
    }

    sendData(workFlowState: SysWorkflowStateDto, workflowName: string, tableName: string, event): void {
        this.onClick.emit({
            workFlowState: workFlowState,
            workflowName: workflowName,
            tableName: tableName,
            event: event
        });
    }

    sendDataFieldCanEdit(): void {
        for (var value of this.lstWorkFlow) {
            if (value.inputCanEdit !== null) {
                this.sendFieldCanEdit.emit({
                    inputCanEdit: value.inputCanEdit.split(',')
                });
            }
        }
    }
}
